import { useQuery } from '@tanstack/react-query';
import { profileApi } from '~/lib/request';

export type ZealyData = {
  id: string;
  name: string;
  email: string;
  xp: number;
  level: number;
  rank: number;
};

function useZealy() {
  const result = useQuery<ZealyData | null>({
    queryKey: ['zealy'],
    queryFn: () => profileApi.get('api/profile/me/zealy').json(),
  });

  return result;
}

export default useZealy;
